<app-offline-indicator />
<div class="main">

</div>
<p-toast></p-toast>
<p-confirmDialog [header]="'COMMON.CONFIRM' | translate"></p-confirmDialog>
<router-outlet />
